// extracted by mini-css-extract-plugin
export default {"title":"_1sFYddVWwSM2kNnCXbDV"};